export default {"src":"/_next/static/media/manage-order.4ab48f3a.svg","height":62,"width":60,"blurWidth":0,"blurHeight":0};